import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=60647655&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60647655",
  null
  
)

export default component.exports